import { WAYPOINT_GET_SUBURBS } from '~~/layers/waypoint/shared/types';
import { useSuburbStore } from '~/stores/useSuburbStore';

// The base-library waypoint component (nuxt-library) owns no authenticated fetch client,
// so it injects its suburb lookup. Provide the app's working getSuburbs (backed by $api).
// Runs after 01.api.ts so $api is registered before useSuburbStore closes over it.
export default defineNuxtPlugin((nuxtApp) => {
	const { getSuburbs } = useSuburbStore();
	if (typeof getSuburbs !== 'function') {
		// Canary for the recent 'suburb lookup not connected' bug: the waypoint
		// component silently disables suburb lookup when this provider is missing.
		frogger.warn('suburb provider not injected — lookup disabled');
	}
	nuxtApp.vueApp.provide(WAYPOINT_GET_SUBURBS, getSuburbs);
});
